// extracted by mini-css-extract-plugin
module.exports = {"only_mobile":"_32bbee5fda--only_mobile--Ms_c3","only_tablet":"_32bbee5fda--only_tablet--t4kE8","only_desktop":"_32bbee5fda--only_desktop--B0ZIy"};